export const layoutImage = {
  banner: 'banner.png',
  level1Nav: 'level1Nav.gif',
  level2Nav: 'level2Nav.gif',
  level3Nav: 'level3Nav.gif',
  customBannerIcon: 'customBannerIcon.png',
  customBannerQRCode: 'customBannerQRCode.png',
  customBannerDarkBackground: 'customBannerDarkBackground.jpg',
  customBannerLightBackground: 'customBannerLightBackground.jpg',
  customBannerPhone: 'customBannerPhone.png',
  customBannerPhoneBackground: 'customBannerPhoneBackground.png',
  navRightSideIcons: 'nav-right-side-icons/{id}.svg',
  hideLogo: 'hideLogo.png',
  showLogo: 'showLogo.png',
  faviconOnDarkMode: 'faviconOnDarkMode.png',
  faviconOnLightMode: 'faviconOnLightMode.png',
};
